exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".slider-piece {\n  text-align: right;\n  outline: none;\n  overflow: hidden;\n  width: calc(100% - 1px) !important; }\n  .slider-piece img {\n    margin: 0 auto;\n    width: 100%; }\n  .slider-piece a.license-link {\n    font-size: 12px;\n    color: #999; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/layout/pieces/Slider/index.scss
// module id = 812
// module chunks = 0